import { useQuery } from "react-query";

import { confirmationService } from "services";

type UseConfirmEmailChangeQueryProps = {
	token: string | null;
	setHasError: Function;
};

const useConfirmEmailChangeQuery = ({
	token,
	setHasError,
}: UseConfirmEmailChangeQueryProps) => {
	const queryResult = useQuery(
		["confirmEmailChange", token],
		() =>
			confirmationService.confirmEmailChange({
				token,
			}),
		{
			onSuccess() {
				setHasError(false);
			},
			onError() {
				setHasError(true);
			},
			enabled: !!token,
			cacheTime: 0,
			retry: false,
		},
	);

	return queryResult;
};

export default useConfirmEmailChangeQuery;
